import * as _ from 'underscore';
import { ISiteSettingsForServerAdminFormScope } from '../../settings/controllers/SiteSettingsForServerAdminFormCtrl';
import { SettingsFormService } from '../../settings/directives/tbSettingsCoordinator';
import { ISiteSettingsForServerAdmin } from '../../settings/types/ISite';
import { ISiteSettingsForSiteAdmin } from '../../settings/types/ISiteSettingsForSiteAdmin';
import { IActionContext } from '../helpers/ActionContext';
import { Module } from '../Module';
import { ConfirmActionDialog } from './ConfirmActionDialog';
import { WebHttpClientWithErrorToast } from '../../httpClient/WebHttpClientWithErrorToast';
import { ModalSize } from './ModalService';
import { ToasterService, ToastType } from './ToasterService';

export class EditSiteAction {

  public static $inject = [
    'ConfirmActionDialog',
    '$translate',
    '$timeout',
    '$q',
    'SettingsFormService'
  ];

  constructor(
    private ConfirmActionDialog: ConfirmActionDialog,
    private $translate: ng.translate.ITranslateService,
    private $timeout: ng.ITimeoutService,
    private $q: ng.IQService,
    private formService: SettingsFormService) { }

  public execute(site: ISiteSettingsForServerAdmin, actionContext: IActionContext): ng.IPromise<any> {
    const dialogScope = <ISiteSettingsForServerAdminFormScope> actionContext.scope.$new();
    dialogScope.sharedForm = this.formService;
    dialogScope.sharedForm.clearForms();
    dialogScope.showEncryptionStatus = true;
    // TODO: pass these scope properties down explicitly in directive
    // instead of using implicit scope inheritance
    dialogScope.siteSettingsForServerAdmin = angular.copy(site);
    dialogScope.siteSettings = {
      siteId: site.id,
      siteAdminSettings: angular.copy(site.siteAdminSettings),
      subscriptionSettings: angular.copy(site.subscriptionSettings)
    } as ISiteSettingsForSiteAdmin;
    dialogScope.isDefaultSite = site.settings.urlName === '';

    return this.ConfirmActionDialog.open({
      scope: dialogScope,
      title: this.$translate.instant('editSiteSettings'),
      bodyTemplateUrl: 'siteDialog.html',
      actionName: this.$translate.instant('save'),
      confirmDisabled: () => _.isEmpty(dialogScope.sharedForm.state) || (dialogScope.sharedForm.state.isFormUnchanged() && dialogScope.sharedForm.state.isFormUnchanged()) || !dialogScope.sharedForm.state.isValid(),
      action: () => {
        return dialogScope.sharedForm.state.save().then(() => {
          _.extend(site, dialogScope.siteSettingsForServerAdmin);
          _.extend(site.siteAdminSettings, dialogScope.siteSettings);
        });
      },
      size: ModalSize.fitToContent
    }).result.finally(() => {
        dialogScope.sharedForm.clearForms();
        dialogScope.$destroy();
      });
  }

}

Module.instance().service('EditSiteAction', EditSiteAction);
